export default {"src":"/_next/static/media/logotype.477c25ad.svg","height":22,"width":107,"blurWidth":0,"blurHeight":0};